var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var mapStudent = function (student, grades) {
    var _a;
    return (__assign(__assign({}, student), { currentGrade: __assign(__assign({}, student.currentGrade), { shortName: (_a = grades.find(function (grade) { var _a; return grade.id === ((_a = student.currentGrade) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.data.shortName }) }));
};
var mapGrades = function (_a) {
    var grades = _a.grades, domains = _a.domains, skills = _a.skills;
    return grades.reduce(function (acc, grade) {
        var gradeSkills = skills.filter(function (el) { return el.gradeId === grade.id; });
        if (gradeSkills.length === 0)
            return acc;
        var gradeDomains = grade.data.domains
            .map(function (name) { return domains.find(function (el) { return el.name === name; }); })
            .filter(function (el) { return gradeSkills.some(function (skill) { return skill.domainId === el.id; }); });
        return __spreadArray(__spreadArray([], acc, true), [
            {
                id: grade.id,
                name: grade.name,
                shortName: grade.data.shortName,
                domains: gradeDomains.map(function (_a) {
                    var data = _a.data, domain = __rest(_a, ["data"]);
                    return {
                        id: domain.id,
                        name: domain.name,
                        position: data.position,
                        skills: gradeSkills.filter(function (skill) { return skill.domainId === domain.id; }),
                    };
                }),
            },
        ], false);
    }, []);
};
var mapSkills = function (dictionarySkills) {
    var assignmentSkills = dictionarySkills.map(function (_a) {
        var data = _a.data, skill = __rest(_a, ["data"]);
        return (__assign(__assign({}, skill), { domainId: data.domainId, gradeId: data.gradeId, position: data.position, category: data.category, guided: data.guided }));
    });
    return assignmentSkills;
};
var mapAssignmentFormInfo = function (dictionaries, groupInfo) {
    var assignmentSkills = mapSkills(dictionaries.skills);
    var grades = mapGrades(__assign(__assign({}, dictionaries), { skills: assignmentSkills }));
    return {
        groupGrade: groupInfo.grade,
        students: groupInfo.students.map(function (el) {
            return mapStudent(el, dictionaries.grades);
        }),
        grades: grades,
        flatSkills: assignmentSkills,
        skipAssessments: groupInfo.skipAssessments,
        minDate: groupInfo.currentDate,
    };
};
export { mapAssignmentFormInfo };
